export function encodeJSONObject(jsonObject){
    
    let jsonString = JSON.stringify(jsonObject);
    minifyMap.forEach(keyValue=>{
        jsonString = jsonString.replaceAll(keyValue[0], keyValue[1]);
    });

    return jsonString
}

export function encodeJSONString(jsonString){
    minifyMap.forEach(keyValue=>{
        jsonString = jsonString.replaceAll(keyValue[0], keyValue[1]);
    });

    return jsonString;    
}

export function decodeJSONObject(jsonObject){
    
    let jsonString = JSON.stringify(jsonObject);
    minifyMap.forEach(keyValue=>{
        jsonString = jsonString.replaceAll(keyValue[1], keyValue[0]);
    });

    let newJsonObject = JSON.parse(jsonString);
    return newJsonObject;   
}

export function decodeJSONString(jsonString){
    minifyMap.forEach(keyValue=>{
        jsonString = jsonString.replaceAll(keyValue[1], keyValue[0]);
    });

    let newJsonObject = JSON.parse(jsonString);
    return newJsonObject;    
}



const minifyMap = [
    ["\"bracket\":","\"1\":"],
    ["\"round\":","\"2\":"],
    ["\"group\":","\"3\":"],
    ["\"players\":","\"4\":"],
    ["\"position\":","\"5\":"],
    ["\"placeholder\":","\"6\":"],
    ["\"name\":","\"7\":"],
    ["\"isBye\":","\"8\":"],
    ["\"previousGroup\":","\"9\":"],
    ["\"previousRound\":","\"10\":"],
    ["\"alternateName\":","\"11\":"],
    ["\"isDoubleElimPossibleFinal\":","\"12\":"],
    ["\"winner\":","\"13\":"],
    ["\"nextOnLoss\":","\"14\":"],
    ["\"seed\":","\"15\":"],
    ["\"id\":","\"16\":"],
    ["\"matchups\":","\"17\":"],
    ["\"isDoubleElimFinal\":","\"18\":"],
    ["\"roundNumber\":","\"19\":"],
];

